import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/audit/')({
  component: () => <Navigate to="/audit/audits" />,
});
